export default __webpack_public_path__ + "static/desktop_landing-xmas-771258953737669593eccf7147f6ad2c.png";